import { defineComponent, ref, toRefs } from "@vue/composition-api";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
export default defineComponent({
  name: "LoginStep",
  components: {
    SimpleButton,
    TextField
  },
  props: {
    email: {
      type: String,
      required: true
    },
    redirectPath: {
      type: String,
      default: "/"
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingStatus: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {
    emit
  }) {
    const password = ref("");
    const {
      email
    } = toRefs(props);
    const handleLogin = async () => {
      if (!password.value || !email.value) return;
      emit("login", {
        email: email.value,
        password: password.value
      });
    };
    return {
      password,
      handleLogin
    };
  }
});